import {Link} from "react-router-dom";
import Button, {BtnColor} from "../../../components/Button/Button";
import {useTranslation} from "react-i18next";

const StepFinish = () => {
    const { t } = useTranslation()
    return (
        <div style={{ width: '100%', height:'100%'}} className="flex justify-end items-center">
            <div className="flex w-1/2 mr-10 z-10">
                <div>
                    <div className="title mt-12">
                        <span className="font-bold text-2xl">
                            🎉 Congratulations your branded app is now live!
                        </span>
                    </div>
                    <div className="subtitle mt-10">
                        <span className="text-sm">
                            Your new app will be published onto the App Stores in the coming days.
                            Make sure to check your email for updates! To make changes and publish a new version of your
                            branded app, return back to the Cheqit configurator at any time.
                        </span>
                    </div>
                    <div className="button justify-center flex mt-28">
                        <a href="/chain/apps">
                            <Button color={BtnColor.gray} className="px-20">Close</Button>
                        </a>
                    </div>
                </div>
            </div>

            <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                height: '100%',
                width: 'calc(90vw - 430px)',
                maxWidth: '50vw'
            }}>
                <div style={{
                    display: 'flex',
                    position: 'relative',
                    textAlign: 'center',
                    width: '100%',
                    height: '100%',
                    zIndex: '1'
                }}>
                    <div style={{
                        position: 'absolute',
                        left: '0',
                        height: '100%',
                        width: '100%',
                        clipPath: 'polygon(0 65px, 60% 28%, 100% 100%, 0% 100%)',
                        zIndex: 0,
                        background: 'linear-gradient(96.89deg, rgba(219, 60, 195, 0.5) 0%, rgba(65, 63, 224, 0.5) 45.83%, rgba(13, 77, 255, 0.5) 100%)'
                    }} />
                    <div style={{
                        position: 'absolute',
                        top: '65px',
                        left: '20px',
                        width: '450px',
                        height: '470px',
                        clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
                        background: 'rgba(222, 249, 249, 0.49)',
                        transform: 'rotate(-8.91deg)'
                    }} />
                    <div style={{
                        position: 'absolute',
                        top: '65px',
                        left: '200px',
                        width: '470px',
                        height: '470px',
                        clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
                        background: 'rgba(222, 249, 249, 0.49)',
                        transform: 'rotate(26.66deg)'
                    }} />
                </div>
            </div>
        </div>
    )
}

export default StepFinish;
